import {useEffect} from "react"
import {useLocation} from "react-router-dom"
import RequireAuth from "../tools/RequireAuth"
import Header from "../sections/header/Header"
import MainNavigation from "../sections/main-navigation/MainNavigation"
import PopupOverlay from "./popup-overlay/PopupOverlay"
import {useLocalContext} from "../reactContext/contextCustomHooks/useLocalContext"
import {useSessionContext} from "../reactContext/contextCustomHooks/useSessionContext"

export default function Layout({children}) {
    let location = useLocation()
    const {localContext} = useLocalContext()
    const {sessionContext} = useSessionContext()
    const sso = location.pathname === "/signin-bouygues" && {client: "bouyges", ssoUrl: "/signin-bouygues"}

    useEffect(() => {
        const bodyNode = document.getElementsByTagName("body")[0]
        bodyNode.style.overflow = "scroll"
    }, [location])

    return (
        <>
        <RequireAuth isLogin={sessionContext.isLogin} sso={sso}>
            <Header/>
            <MainNavigation/>
            <PopupOverlay/>
        </RequireAuth>
        <main className={(sessionContext.isLogin && localContext.minNavigation) ? "lg" : (sessionContext.isLogin && localContext.minNavigation === false) ? "xs" : sessionContext.isLogin ? "is-login" : "disconnect"}>{children}</main>
        </>
    )
}